/* ShellyMadrid - regalo 2o pedido (REGALO2PEDIDO), 3-nov-2026 (v2 4-nov: punteras) */
(function(){var st=document.createElement('style');st.textContent="\n  .sm-regalo{margin:0 0 12px;padding:12px 14px;border:1px solid #d9d9d9;border-radius:6px;background:#f7f7f7;font-size:14px;line-height:1.4;color:#111}\n  .sm-regalo strong{font-weight:700}\n  .sm-regalo__bar{height:6px;background:#e3e3e3;border-radius:3px;margin-top:8px;overflow:hidden}\n  .sm-regalo__bar span{display:block;height:100%;background:#111}\n  .sm-regalo__btns{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}\n  .sm-regalo__btns button{flex:1 1 140px;padding:10px 8px;border:1px solid #111;border-radius:4px;background:#fff;color:#111;font-size:13px;font-weight:600;cursor:pointer;line-height:1.2}\n  .sm-regalo__btns button:hover{background:#111;color:#fff}\n  .sm-regalo__btns button[disabled]{opacity:.5;cursor:wait}\n  .sm-regalo small{display:block;margin-top:6px;color:#555;font-size:12px}\n";(document.head||document.documentElement).appendChild(st);})();

(function () {
  var KEY = 'smRegalo2Pedido';
  var DAYS = 21;
  var MIN = 6000; // 60,00 € en céntimos
  var GIFTS = [
    { id: 51546748780877, label: 'Añadir RC Snubber gratis', hint: 'para motores' },
    { id: 52455422820685, label: 'Añadir 100 punteras gratis', hint: 'para cable flexible de 1,5 mm²' }
  ];
  var GIFT_IDS = GIFTS.map(function (g) { return g.id; });

  function store(get, val) {
    try {
      if (get) return window.localStorage.getItem(KEY);
      window.localStorage.setItem(KEY, val);
    } catch (e) { return null; }
  }

  // Marca la visita desde el correo
  var params = new URLSearchParams(window.location.search);
  if (params.get('regalo') === '1' || window.location.pathname.indexOf('/collections/regalo-segundo-pedido') === 0) {
    store(false, String(Date.now()));
  }
  var since = parseInt(store(true) || '0', 10);
  if (!since || Date.now() - since > DAYS * 86400000) return;

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function html(cart) {
    var base = 0, hasGift = false;
    (cart.items || []).forEach(function (it) {
      if (GIFT_IDS.indexOf(it.variant_id) > -1) { hasGift = true; }
      else { base += it.original_line_price; }
    });
    if (!cart.item_count) return '';
    if (base < MIN) {
      var pct = Math.max(4, Math.min(100, Math.round(base / MIN * 100)));
      return '<div>Te faltan <strong>' + euros(MIN - base) + '</strong> para tu regalo: un RC Snubber o una bolsa de 100 punteras.</div>' +
        '<div class="sm-regalo__bar"><span style="width:' + pct + '%"></span></div>' +
        (hasGift ? '<small>El regalo solo sale a 0 € en pedidos de más de 60 €.</small>' : '');
    }
    if (hasGift) {
      return '<div><strong>✓ Tu regalo está en el carrito.</strong> Se queda a 0 € al finalizar el pedido.</div>';
    }
    return '<div><strong>Elige tu regalo</strong> (uno por pedido):</div><div class="sm-regalo__btns">' +
      GIFTS.map(function (g) {
        return '<button type="button" data-sm-regalo="' + g.id + '">' + g.label + '<br><span style="font-weight:400;font-size:12px">' + g.hint + '</span></button>';
      }).join('') + '</div><small>Se queda a 0 € al finalizar el pedido.</small>';
  }

  var busy = false;
  function render() {
    if (busy) return;
    var anchors = document.querySelectorAll('#CartDrawerForm [data-subtotal], #CartPageForm [data-subtotal]');
    if (!anchors.length) return;
    busy = true;
    window.fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var content = html(cart);
        anchors.forEach(function (sub) {
          var row = sub.closest('.cart__item-row') || sub.parentNode;
          var box = row.parentNode.querySelector('.sm-regalo');
          if (!content) { if (box) box.remove(); return; }
          if (!box) {
            box = document.createElement('div');
            box.className = 'sm-regalo';
            row.parentNode.insertBefore(box, row);
          }
          if (box.innerHTML !== content) box.innerHTML = content;
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-sm-regalo]');
    if (!btn) return;
    ev.preventDefault();
    btn.disabled = true;
    window.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-sm-regalo'), 10), quantity: 1 }] })
    }).then(function () {
      if (document.getElementById('CartPageForm')) { window.location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(render, 600);
    }).catch(function () { btn.disabled = false; });
  });

  // Recalcular cuando el carrito cambia (añadir, quitar, cantidades)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url || arguments[0] || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(render, 400); });
    }
    return p;
  };
  ['cart:updated', 'cart:open', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(render, 300); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
